export default __webpack_public_path__ + "static/media/Borders.dc9d456c.gif";